var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureNoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.333 30.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.449,14.449H0V0H14.449Z",
    fill: "#f1511b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.449,14.449H177V0h14.447V14.449Z",
    transform: "translate(-161.115)",
    fill: "#80cc28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.449,191.449H0V177H14.449Z",
    transform: "translate(0 -161.115)",
    fill: "#00adef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.449,191.449H177V177h14.447v14.449Z",
    transform: "translate(-161.115 -161.115)",
    fill: "#fbbc09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureNoCircle);
export default __webpack_public_path__ + "static/media/azure-no-circle.20b53aeae72d098dd5f18ccf6d379c4c.svg";
export { ForwardRef as ReactComponent };